import httpClient from './httpClient'

export default {
  async getSubscription(noCache = false) {
    let ret
    if (noCache) {
      ret = await httpClient.get('stripe/subscription', {
        headers: {
          'Cache-Control': 'max-age=0',
        },
      })
      return ret
    }
    ret = await httpClient.get('stripe/subscription')
    return ret
  },
  async updateSubscription(data) {
    let ret = await httpClient.put('stripe/subscription', data)
    return ret
  },
  async deleteBillingScheduling(date) {
    let ret = await httpClient.delete(
      `/stripe/subscription?id_due_date=${date}`
    )
    return ret
  },
  async deleteCard(cardId) {
    let ret = await httpClient.delete(`/stripe/source?source_id=${cardId}`)
    return ret
  },
  async getPlans(currency) {
    let ret = await httpClient.get(`stripe/product?currency=${currency}`)
    return ret
  },
  async subscribeToPlan(type) {
    let ret = await httpClient.post('stripe/subscription', { type })
    return ret
  },
  async addCard(cardToken) {
    let ret = await httpClient.post('/stripe/source', {
      source_token: cardToken,
    })
    return ret
  },
  async addBoleto(boletoInfo) {
    let ret = await httpClient.post('/stripe/source', {
      type: 'boleto',
      boleto_details: boletoInfo,
    })
    return ret
  },
  async updateAddress(data) {
    let ret = await httpClient.put('stripe/subscription', data)
    return ret
  },
  async getCards() {
    let ret = await httpClient.get('/stripe/source')
    return ret
  },
  async changeDefaultCard(cardId) {
    let ret = await httpClient.put('/stripe/source?action=change-default', {
      source_id: cardId,
    })
    return ret
  },
  async setAddon(data) {
    let ret = await httpClient.post('stripe/subscription', data)
    return ret
  },
  async previewInvoice(userPlanId, lang, items) {
    let ret = await httpClient.post('stripe/subscription?action=preview', {
      subscription_id: userPlanId,
      lang: lang,
      items: items,
    })
    return ret
  },
  async resetBillingCycle(status) {
    let ret = await httpClient.post('stripe/subscription?action=trial_end', {
      status: status,
    })
    return ret
  },
  async getReturnUrl(returnUrl, locale, token) {
    let to = `/stripe/customer?return_url=${returnUrl}&locale=${locale}`
    if (token) to += `&unsubscribe_token=${token}`
    let ret = await httpClient.post(to)
    return ret
  },
  async getBoletoUrl(successUrl, cancelUrl, locale) {
    let to = '/stripe/source?createLinkAddCard'
    let ret = await httpClient.post(to, {
      success_url: successUrl,
      cancel_url: cancelUrl,
      locale: locale,
    })
    return ret
  },
  async createSession(successUrl, cancelUrl, items) {
    let ret = await httpClient.post('stripe/subscription?action=preview', {
      items: items,
      success_url: successUrl,
      cancel_url: cancelUrl,
    })
    return ret
  },
  async forcePayment(invoiceId, paymentMethod) {
    let dataObject = {
      invoice_id: invoiceId,
    }
    if (paymentMethod) {
      dataObject['payment_method'] = paymentMethod
    }
    let ret = await httpClient.post(
      'stripe/invoices?force_invoice_payment=1',
      dataObject
    )
    return ret
  },
  async activePosCharge() {
    let ret = await httpClient.post(
      'stripe/subscription?action=trusted_charge_pos'
    )
    return ret
  },
}
